import Keycloak from 'keycloak-js';
import config from './config.js';
import logger from './utils/logger.js';

// Singleton pattern to prevent multiple Keycloak instances
let keycloakInstance = null;

const createKeycloakInstance = () => {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak({
      url: config.keycloak.url,
      realm: config.keycloak.realm,
      clientId: config.keycloak.clientId,
    });

    // Prevent re-initialization by marking as initialized
    keycloakInstance._initialized = false;
  }
  return keycloakInstance;
};

const keycloak = createKeycloakInstance();

// Make Keycloak instance globally available for debugging and token refresh
if (typeof window !== 'undefined') {
  window.keycloak = keycloak;
}

// Override the init method to prevent multiple initializations
const originalInit = keycloak.init;
keycloak.init = function (options) {
  if (this._initialized) {
    logger.warn('Keycloak instance already initialized, skipping...');
    return Promise.resolve(true);
  }

  this._initialized = true;
  return originalInit.call(this, options);
};

export default keycloak;
